import {
  getArrayFromLocalStorage,
  reduceArrayToMatchMaxLength
} from "@dealer-center/core-components";
import { useLocalStorageKeys } from "@dealer-center/core-interfaces-components";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AccountFavoritesState {
  accountFavorites: string[];
  toggleAccountFavorites: (accountId: string) => void;
  addToAccountFavorites: (accountId: string) => void;
  removeFromAccountFavorites: (accountId: string) => void;
}

const key = useLocalStorageKeys.ddcAccountFavorites;

export const useAccountFavourites = create<AccountFavoritesState>()(
  persist(
    (set, get) => ({
      accountFavorites: getArrayFromLocalStorage<string>(key),
      toggleAccountFavorites: (accountId: string) => {
        set(state => {
          if (state.accountFavorites.includes(accountId)) {
            return {
              accountFavorites: state.accountFavorites.filter(
                id => id !== accountId
              )
            };
          } else {
            return { accountFavorites: [accountId, ...state.accountFavorites] };
          }
        });
      },
      addToAccountFavorites: (accountId: string) => {
        set(state => {
          const existingListWithoutItem = state.accountFavorites.filter(
            id => id !== accountId
          );
          const itemsToSet = reduceArrayToMatchMaxLength(
            [accountId, ...existingListWithoutItem],
            key
          );
          return { accountFavorites: itemsToSet };
        });
      },
      removeFromAccountFavorites: (accountId: string) => {
        set(state => {
          const existingListWithoutItem = state.accountFavorites.filter(
            id => id !== accountId
          );
          return { accountFavorites: existingListWithoutItem };
        });
      }
    }),
    {
      name: key
    }
  )
);
